import { DataGrid } from "devextreme-react";
import { Column, MasterDetail } from "devextreme-react/data-grid";
import styled from "styled-components";

const AuditTrailsGridWrapper = styled.div`
  width: 800px;
  height: 100%;
  background-color: white;
  padding: 20px 40px;
  .dx-master-detail-row {
    .dx-datagrid-headers {
      background-color: #e2efda;
    }
  }
  #issueId {
    span {
      display: inline-block;
      padding: 8px 16px;
      background-color: white;
      width: 565px;
      margin: 0;
      border: 1px solid #e4e4e4;
      border-bottom: none;
      &:first-child {
        background-color: #e2efda;
        width: 100px;
        text-align: center;
        font-weight: bold;
        border-right: none;
      }
    }
  }

`;

const AuditTrailsGrid = ({ dataSource, renderAuditTrailsDetailView }) => {
  return (
    <AuditTrailsGridWrapper>
      <DataGrid
        allowColumnResizing={true}
        columnResizingMode={"nextColumn"}
        dataSource={dataSource}
        height={550}
        showBorders={true}
        showColumnLines={true}
        width={700}
        wordWrapEnabled={true}
      >
        <Column dataField="name" alignment="center" caption="작성자" />
        <Column dataField="employeeNo" alignment="center" caption="사번" />
        <Column dataField="date" alignment="center" caption="수정일" dataType="date" format="yyyy-MM-dd" />
        <MasterDetail enabled={true} render={renderAuditTrailsDetailView} />
      </DataGrid>
    </AuditTrailsGridWrapper>
  );
};

export default AuditTrailsGrid;
